import * as React from 'react';

import { GetOnlineButton } from '../GetOnlineButton';

interface ITitleColumnRightProps {
  isGetOnlineButtonAvailable: boolean;
  mortgagePartnerLink: string;
  onGetOnlineButtonClick: (event: React.MouseEvent) => void;
}

export const TitleColumnRight: React.FC<ITitleColumnRightProps> = ({
  isGetOnlineButtonAvailable,
  mortgagePartnerLink,
  onGetOnlineButtonClick,
}) => {
  if (isGetOnlineButtonAvailable) {
    return <GetOnlineButton href={mortgagePartnerLink} onClick={onGetOnlineButtonClick} />;
  }

  return null;
};
